/**************************************************
 * Nombre:       Escuela_Detalle_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import '@splidejs/react-splide/css';
import fondo from '../../../Recursos/fondos.png'
import {NEGRITA} from "../../../Constantes";
import iso from "../../../Recursos/iso_azul.svg";
import tecni from '../../../Recursos/Temporales/equipo.png'
import {School} from '@mui/icons-material'


const Escuela_Detalle_Portada = () => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                mt: -12,
                backgroundImage: `url(${fondo})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
            }}
        >


            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff', pt: 12}}
            >

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 11}}>


                    <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                        >


                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                                <Typography sx={{fontSize: 60, fontWeight: 600, fontFamily: NEGRITA, lineHeight: 1.1}}>

                                    <School sx={{fill: '#fff', height: 62, width: 62, pr: 2, mt: 1, mb: -1}}/>
                                    Escuela de Administración Y Negocios
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                                <Typography sx={{fontSize: 18, fontWeight: 400}}>
                                    Es un ecosistema de innovación que fusiona el rigor académico con la práctica
                                    empresarial. A través de proyectos de investigación liderados por expertos,
                                    potenciamos tus competencias para que lideres el mercado con excelencia y visión
                                    estratégica.
                                </Typography>
                            </Grid>



                        </Grid>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-end', mt: 12}}>
                        <img src={tecni} width={'90%'}/>
                    </Grid>

                </Grid>


            </Grid>


        </Grid>
    )

}
export default Escuela_Detalle_Portada

